import { convertTimeLetter, formatTimeEvent } from '@helpers';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { NCFileDetailsScreenName } from '@v2/pages/nc-file/details/navigation/config';
import { NCFileDetailsScreen } from '@v2/pages/nc-file/details/common/enums/ncFileDetails.enum';
import { Perspective } from '@v2/pages/common/enums';
import type { NCFileSearchItem } from '@interfaces/search';
import type { NCFileListProps } from '@components/machines/components/detailsComponents/activeMachine/components/NCFilesList/types';

export interface UseManageNCFilesListParams extends Pick<NCFileListProps, 'ncFilesByPartId'> {}

export const useManageNCFilesList = ({ ncFilesByPartId }: UseManageNCFilesListParams) => {
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const selectedNCFile = (item: NCFileSearchItem) => {
    navigateToMainDetailsScreen({
      mainScreen: NCFileDetailsScreenName,
      subScreen: NCFileDetailsScreen.NC_FILE,
      params: {
        perspective: Perspective.NC_FILE,
        ncFileName: item.ncFileName,
        ncFileId: item.ncFileId,
        ncFileStatus: item.ncFileStatus,
      },
    });
  };

  const ncFilesByPartIdFormatted = ncFilesByPartId.map((i) => ({
    ...i,
    runTimePerPcsSecondFormatted: formatTimeEvent(convertTimeLetter(i.runTimePerPcsSecond), false),
    changeTimePerPcsSecondFormatted: formatTimeEvent(convertTimeLetter(i.changeTimePerPcsSecond), false),
    setupTimeSecondFormatted: formatTimeEvent(convertTimeLetter(i.setupTimeSecond), false),
  }));

  return {
    selectedNCFile,
    ncFilesByPartIdFormatted,
  };
};
